import mainLogo from '../../images/Topcar/TopCar_Audi_logo_black.png';
import squareLogo from '../../images/Topcar/TopCar_Audi_logo_square_black.png';
import mainLogoWhite from '../../images/Topcar/TopCar_Audi_logo_white.png';
import bannerLogoWhite from '../../images/Topcar/TopCar_Audi_logo_square_white.png';
import banner01 from '../../images/Topcar/TopCar_Banner_02.webp';
import banner02 from '../../images/Topcar/TopCar_Banner_01.webp';
import banner03 from '../../images/Vigorito/concessionaria_faixa_vigorito_nissan.webp';
import banner04 from '../../images/Vigorito/concessionaria_faixa_vigorito_vw_2.webp';
import bannerBrands from '../../images/Vigorito/carros_faixa_VigoritoBrands.jpg';
import aboutUsBg from '../../images/Topcar/TopCar_Banner_01.webp';
import paymentImg from '../../images/Topcar/TopCar_Audi_logo_black.png';
import paymentImgMobile from '../../images/Topcar/TopCar_Audi_logo_square_black.png';
import car123 from '../../images/Topcar/123_audi.jpg';
import box123 from '../../images/Topcar/123_topcar.jpg';
import { SliderProducts } from '../../Utilities/SliderProducts';

export const configData = {
    defaultStore: 'Peças Topcar',
    defaultStoreLink: 'pecas.auditopcar.com.br',
    defaultContactEmail: 'audi.pecas@auditopcar.com.br',
    whatsappNumber: '51 99140 6251',
    CNPJ: '09.191.427/0002-70',
    CNPJname: 'INTERCONTINENTAL COMERCIO DE VEICULOS S/A',
    CNPJaddress: 'Av. Ceará, 724, São João - Porto Alegre, RS - 90.240-510',
    launchDate: '01/02/2025',

    multiContact: {},
    searchByPlate: false,

    coupons: [
        // {
        //     coupon: '10PORCENTO',
        //     discountPrice: 0,
        //     discountPercent: 0.1,
        //     freeShipping: false,
        // },
        // {
        //     coupon: '10REAIS',
        //     discountPrice: 10,
        //     discountPercent: 0,
        //     freeShipping: false,
        // },
        // {
        //     coupon: 'FRETEGRATIS',
        //     discountPrice: 0,
        //     discountPercent: 0,
        //     freeShipping: true,
        // },
    ],

    brands: [
        'audi',
    ],

    homologBrands: [
        'motorcraft',
        'motrio',
        'acdelco',
        'mopar',
        'bproauto',
    ],

    noVehicle: false,

    storeSellersWarehouses: [
        "INTERCONTINENTAL POA",
        "INTERCONTINENTAL CAXIAS",
    ],

    disabledSellers: [],

    useMktNames: false,

    endYear: 2025,
    startYear: 1996,

    payment: {
        maxParcels: 6,
        checkoutParcels: {
            0: 1,
            200: 2,
            300: 3,
            400: 4,
            500: 5,
            600: 6,
        }
    },

    customShipping: {
        deliveryTime: 1,
    },

    productSlider: [
        // {
        //     name: 'Kits',
        //     img: 'tabKits',
        //     products: SliderProducts.Kits
        // },
        {
            name: 'Óleos',
            img: 'tabOleos',
            products: SliderProducts.Oleos
        },
        {
            name: 'Filtros',
            img: 'tabFiltros',
            products: SliderProducts.Filtros
            // products: SliderProducts.FiltrosAudi
        },
        {
            name: 'Acessórios',
            img: 'tabAcessorios',
            products: SliderProducts.Acessorios
        },
        {
            name: 'Roupas',
            img: 'tabRoupas',
            products: SliderProducts.Roupas
        }
    ]
}

export const contentData = {
    mainLogo: mainLogo,
    squareLogo: squareLogo,
    mainLogoWhite: mainLogoWhite,
    bannerLogoWhite: bannerLogoWhite,

    banner01: banner01,
    banner02: banner02,
    banner03: banner03,
    banner04: banner04,
    bannerBrands: bannerBrands,
    aboutUsBg: aboutUsBg,

    box123: box123,
    car123: car123,
    
    paymentImg: paymentImgMobile,
    paymentImgMobile: paymentImgMobile,

    bannerHighlight: 'Compre peças <mark>novas e originais</mark>, compatíveis com seu <mark>Audi</mark>. Peças <mark>genuínas</mark> direto das concessionárias <mark>Audi Top Car</mark>.',

    aboutUs: {
        title: 'Quem somos',
        content: [
            'Trabalhando com automóveis de luxo desde a década de 90, o Grupo Top Car sempre primou pelo alto nível de atendimento em suas lojas distribuídas pelas maiores cidades de Santa Catarina e Rio grande do Sul. Com o passar do tempo, a Top Car atingiu um patamar único de qualidade e hoje é reconhecida por sua excelência em atendimento e representatividade no segmento. Em 2015 a Top Car se associou a Sojitz Corporation, conglomerado Japonês centenário com 400 subsidiárias e afiliadas localizadas no Japão e no mundo.',
        ],
        link: 'https://grupotopcar.com.br/quem-somos.html',
        linkCta: 'Saiba mais',
    },

    socialMedia: {
        Instagram: 'https://www.instagram.com/topcar.audi/',
        Facebook: 'https://www.facebook.com/topcar.audi/',
        LinkedIn: 'https://www.linkedin.com/company/auditopcar/',
        Youtube: '',
        Twitter: '',
    },

    footerContent: [],
}